import React, { FC, ChangeEvent, useState } from 'react';
import { TextField, Button } from '@mui/material';
import { Filters } from './types';
import { ListingsSummary } from '../../graphql/generated';
import BrowsingFiltersDropdown from '../../Components/Menus/BrowsingFiltersDropdown';

interface ListingsCategoryFiltersProps {
  onFiltersSubmit: (filters: Filters) => void;
  listingsSummary: ListingsSummary;
}

const ListingsCategoryFilters: FC<ListingsCategoryFiltersProps> = ({ onFiltersSubmit, listingsSummary }) => {
  const [brand, setBrand] = useState<string>('');
  const [size, setSize] = useState<string>('');
  const [search, setSearch] = useState<string>('');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | ''>('');
  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value);

  const handleSortToggle = () => {
    // Cycle between ascending, descending, and unselected states
    setSortOrder((prev) => (prev === '' ? 'asc' : prev === 'asc' ? 'desc' : ''));
    handleSubmit();
  };

  const handleSubmit = () => {
    onFiltersSubmit({ brand, size, search, sortOrder });
  };

  const handleSetBrand = (selectedBrand: string) => {
    setBrand(selectedBrand);
    onFiltersSubmit({ brand: selectedBrand, size, search, sortOrder });

  }

  const handleSetSize = (selectedSize: string) => {
    setSize(selectedSize);
    onFiltersSubmit({ brand, size: selectedSize, search, sortOrder });
  }

  return (
    <>
      <BrowsingFiltersDropdown
        title='Brand'
        options={listingsSummary.brands || []}
        setFilter={handleSetBrand}
      />
      <BrowsingFiltersDropdown
        title='Size'
        options={listingsSummary.sizes || []}
        setFilter={handleSetSize}
      />
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        value={search}
        onChange={handleSearchChange}
        fullWidth
      />
      <Button variant="outlined" onClick={handleSortToggle} sx={{"min-width": "124px"}}>
        {sortOrder === '' ? 'Sort by Price' : `Price: ${sortOrder === 'asc' ? 'Low to High' : 'High to Low'}`}
      </Button>
      <Button variant="contained" onClick={handleSubmit}>
        Apply
      </Button>
    </>
  );
};

export default ListingsCategoryFilters;
